/* eslint-disable import/no-extraneous-dependencies */
import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { enqueueSnackbar } from "notistack";

import { FormButton } from "../../../components/FormButton";
import { Input } from "../../../components/Input";
import { AuthContext } from "../../../contexts/AuthContext";
import { api } from "../../../services/api";
import { PageTitle } from "../../../components/PageTitle";

interface Zone {
  name: string;
  color: string;
}

const schema = Yup.object().shape({
  name: Yup.string().required("Campo zona é obrigatório"),
  color: Yup.string().required("Campo cor é obrigatório"),
});

export function ZoneEdit() {
  const { user } = useContext(AuthContext);
  const { id } = useParams();
  const [zone, setZone] = useState<Zone>();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      api.get(`zones/${id}`).then(response => {
        return setZone(response.data);
      });
    }
  }, [id]);

  function handleSubmit(data: Zone) {
    if (id) {
      api
        .put(`/zones/${id}`, data)
        .then(() => {
          enqueueSnackbar("Zona editada com sucesso!", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        })
        .catch(({ response }) => {
          enqueueSnackbar(response.data.message, {
            variant: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        });
    } else {
      api
        .post("/zones", data)
        .then(() => {
          enqueueSnackbar("Zona cadastrada com sucesso!", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        })
        .catch(({ response }) => {
          enqueueSnackbar(response.data.message, {
            variant: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        });
    }
    return navigate("/zones");
  }

  const initialValues = {
    name: zone ? zone.name : "",
    color: zone ? zone.color : "#0085BD",
  };

  return (
    <div className="container mx-auto">
      <PageTitle
        title={id ? "Editar Zona" : "Nova Zona"}
        backButton
        backPath="/zones"
      />
      <div className="w-full">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={schema}
            onSubmit={values => {
              handleSubmit(values);
            }}
          >
            {({ errors, values, setFieldValue }) => (
              <Form className="space-y-4">
                <div className="space-y-2">
                  <span className="text-sm text-[#0085BD] font-medium">
                    Zona
                  </span>
                  <Input
                    type="text"
                    name="name"
                    placeholder="Zona"
                    error={errors.name}
                    className="h-[52px] px-4 w-full rounded-lg text-[#7FA5B2] bg-white border border-gray-200 focus:border-[#0085BD] focus:ring-1 focus:ring-[#0085BD]"
                  />
                </div>
                <div className="space-y-2">
                  <span className="text-sm text-[#0085BD] font-medium">
                    Cor da Zona
                  </span>
                  <div className="flex items-center gap-4">
                    <input
                      type="color"
                      value={values.color}
                      onChange={e => setFieldValue("color", e.target.value)}
                      className="w-16 h-12 rounded-lg border border-gray-200 cursor-pointer"
                    />
                    <input
                      type="text"
                      value={values.color}
                      onChange={e => setFieldValue("color", e.target.value)}
                      placeholder="#0085BD"
                      className="h-[52px] px-4 w-32 rounded-lg text-[#7FA5B2] bg-white border border-gray-200 focus:border-[#0085BD] focus:ring-1 focus:ring-[#0085BD] uppercase"
                    />
                    <div
                      className="w-12 h-12 rounded-full border-2 border-white shadow-md"
                      style={{ backgroundColor: values.color }}
                    />
                  </div>
                  {errors.color && (
                    <span className="text-red-500 text-sm">{errors.color}</span>
                  )}
                </div>
                <FormButton
                  title={id ? "Editar Zona" : "Cadastrar Zona"}
                  type="submit"
                />
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}
